import React from 'react';
import Box from '@mui/material/Box';

import './ComingSoon.css';

type ComingSoonProps = {
  children?: React.ReactNode;
};

const ComingSoon: React.FC<ComingSoonProps> = (props: ComingSoonProps) => {
  const { children } = props;
  return (
    <Box className="ComingSoon">
      <Box className="ComingSoon-label">Coming Soon</Box>
      {children}
    </Box>
  );
};

export { ComingSoon };
